export default __webpack_public_path__ + "static/media/GA_ReSynth-1.bae22df4.wav";